export const pageContent = {
  slideX: {
    slideContent:
      "The text content for the given slide, usually a paragraph or two. In the intro slide, this content represents the DEK. If the text includes more than one paragraph, just write {newParagraph} in between to split it up. Do not separate the paragraphs with line breaks.",
    photoFileName:
      "The file name of the photo that goes with the content above. The name needs to match exactly and include the suffix at the end (for example: “060223_fort_greene_interrupters_crop_1.jpg”) If left blank, the content will show up on a blank screen. (OPTIONAL)",
    photoPosition:
      "For engineers to fill out. This specifies what part of the photo should be centered on mobile. (OPTIONAL)",
  },
  introText: {
    introText:
      "This is one of the unsung areas that powers the city. {newParagraph} The southwest Bronx has one of the city’s largest populations of service workers who rely on public transit to get to work, according to the U.S. Census Bureau and Department of City Planning. {newParagraph} Now, new affordable developments in the area — including Bronx Point, which houses the museum — are designed to keep rents at reasonable levels for the people who live here but help feed and provide care for New Yorkers across the five boroughs. {newParagraph} “You have to continue to build affordable housing and to allow the people who were born and raised [in The Bronx], who made the city what it is, be able to live there,” said Bronx Point project manager and native Bronxite Josue Sanchez. {newParagraph} “Those are the people that make the city run, give it its identity, its flavor, its culture.”",
  },
  slide0: {
    slideContent:
      "Construction worker Angel Comara puts finishing touches on a bathroom inside the Universal Hip Hop Museum next to Mill Pond Park.",
    photoFileName: "012524_12_hours_concourse_10.jpg",
    photoPosition: "45%",
  },
  slide1: {
    slideContent:
      "The zone stretches from the soon-to-open Universal Hip Hop Museum at East 149th Street to just north of the historic High Bridge at West 172nd Street. It includes the Concourse and Highbridge neighborhoods and the northern tip of Mott Haven as well.",
    photoFileName: "map.jpeg",
    photoPosition: "57%",
  },
  slide3: {
    slideContent:
      "With nearly 70% of residents in the area relying on public transit to get to work, dependable service is essential. {newParagraph} “The transportation is incredible,” Sanchez said. “You can get to the east and west side of Midtown Manhattan in minutes.”",
    photoFileName: "012524_12_hours_concourse_19.jpg",
    photoPosition: "31%",
  },
  slide4: {
    slideContent:
      "“People now they can live, they have a place to stay,” 153 Deli worker and local resident Abdul Ali said about new developments in the area. “It’s good for business.”",
    photoFileName: "012524_12_hours_concourse_4.jpg",
    photoPosition: "40%",
  },
  slide5: {
    slideContent:
      "Construction workers Franklin Marmolejos, left, and Troy Gayle take a break from building a school near East 149th Street.",
    photoFileName: "012524_12_hours_concourse_5.jpg",
    photoPosition: "65%",
  },
  slide6: {
    slideContent:
      "A recently constructed building with affordable units sits between Yankee Stadium and older residential blocks.",
    photoFileName: "012524_12_hours_concourse_17.jpg",
    photoPosition: "65%",
  },
  slide7: {
    slideContent:
      "Kaci New heads home to Hell’s Kitchen after working the overnight surgical trauma shift at Lincoln Hospital on East 149th Street. {newParagraph} “I see some crazy stuff,” New said about her job.",
    photoFileName: "012524_12_hours_concourse_3.jpg",
    photoPosition: "",
  },
  slide8: {
    slideContent:
      'Attorney Sondah Ouattara walks her African hunting dog, Cairo, in Franz Sigel Park near East 153rd Street. {newParagraph} “I go to the park at least once a day because of my dog,” said Ouattara, who also volunteers for park cleanups organized by the <a href="https://www.friendsof4.org/">Friends of 4 Parks Alliance</a>. “I also use the dog run. In the summertime during the day, my friends and I from the neighborhood, we will have picnics in the park, enjoy the green space.”',
    photoFileName: "012524_12_hours_concourse_6.jpg",
    photoPosition: "",
  },
  slide9: {
    slideContent:
      "Performer and podcaster Wayne Payne enjoys a cigar break at Papa Juan Cigar Room near Yankee Stadium. {newParagraph} “All the transit leads you to any line,” Payne said about the subway options in the area that help him get to casting calls.",
    photoFileName: "012524_12_hours_concourse_8.jpg",
    photoPosition: "75%",
  },
  slide10: {
    slideContent:
      "A group of teens takes shots on goal in Rev. T. Wendell Foster Park at East 165th Street.",
    photoFileName: "012524_12_hours_concourse_9.jpg",
    photoPosition: "27%",
  },
  slide11: {
    slideContent:
      "People traverse the High Bridge — the oldest standing bridge in the city — which connects The Bronx to Washington Heights in Manhattan.",
    photoFileName: "012524_12_hours_concourse_13.jpg",
    photoPosition: "",
  },
  slide12: {
    slideContent:
      "The Yankees loom large in the off-season along River Avenue near the stadium.",
    photoFileName: "012524_12_hours_concourse_16.jpg",
    photoPosition: "75%",
  },
  slide13: {
    slideContent:
      "The evening commute at the 161st Street-Yankee Stadium station.",
    photoFileName: "012524_12_hours_concourse_18.jpg",
    photoPosition: "",
  },
};
